import React, { forwardRef } from 'react';
import { InputDefaultContainer, InputDefaultLabel, InputDefaultField, InputDefaultMessageError } from './styles';

const InputDefaultOnlyText = forwardRef((props, ref) => {
  //Se utiliza 
  const handleInputChange = (event) => {
    const newValue = event.target.value.replace(/[^A-Za-záéíóúüñÁÉÍÓÚÜÑ\s\-,.]/g, '');

    if (props.onChange) {
      props.onChange({
        ...event,
        target: {
          ...event.target,
          value: newValue,
        },
      });
    }
  };

  return (
    <InputDefaultContainer id="input-text">
      <InputDefaultLabel htmlFor={props.id}>{props.label}</InputDefaultLabel>
      <InputDefaultField
        name={props.name}
        defaultValue={props.value}
        ref={props.register}
        className={props.error && 'error'}
        readOnly={props.readOnly}
        onChange={handleInputChange} 
        onClick={props.onClick}
        autoComplete={props.autoComplete}
        maxLength={props.maxLength}
        minLength={props.minLength}
        id={props.id}
        type={props.type}
      />
      {props.error && <InputDefaultMessageError error={props.error}>{props.error.message}</InputDefaultMessageError>}
    </InputDefaultContainer>
  );
});

export default InputDefaultOnlyText;
